// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Enterprise scope for admin and partner roles.
 * Applied via the .portal-enterprise class on the app shell in App.tsx.
 * Designed to be subtle and additive: signals "this is operations tooling" without
 * restructuring legacy admin layouts. Most rules are gentle visual shifts.
 */

.portal-enterprise {
  background: linear-gradient(180deg, #fafbfd 0%, #f3f6fa 100%);
}

/* Tighten the type on admin page headers */
.portal-enterprise .page-header h1,
.portal-enterprise .recruiter-page-header__copy h1 {
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #0b1220;
}

.portal-enterprise .page-header p,
.portal-enterprise .page-header .muted {
  color: #6a7689;
  font-size: 0.875rem;
}

/* Cards: less rounded, more enterprise table-tool feel */
.portal-enterprise .card,
.portal-enterprise .card--toolbar {
  border-color: #e3e7ee;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(15,23,42,0.04);
}

/* Default text color slightly cooler */
.portal-enterprise,
.portal-enterprise body,
.portal-enterprise .container {
  color: #2c3a52;
}

/* Tables: tighter rows, subtle zebra */
.portal-enterprise table {
  font-size: 0.8125rem;
}
.portal-enterprise table thead th {
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-size: 0.6875rem;
  color: #6a7689;
  background: #f6f8fb;
  font-weight: 700;
}
.portal-enterprise table tbody tr:nth-child(even) td {
  background: #fafbfd;
}

/* Status pills: keep them clear but reduce rounding */
.portal-enterprise .status-pill,
.portal-enterprise .badge {
  border-radius: 6px;
  font-weight: 600;
}

/* Filter sections: tighten */
.portal-enterprise .filters-section {
  border-radius: 10px;
  background: #ffffff;
  border: 1px solid #e3e7ee;
}

/* Buttons: slightly less rounded */
.portal-enterprise .btn {
  border-radius: 8px;
}

/* Sidebar (legacy admin sidebar still applies): make it a touch more reserved */
.portal-enterprise .sidebar {
  background: linear-gradient(180deg, #16213b 0%, #1d2a48 100%);
}

/* ---------------------------------------------------------------- */
/* Explicit enterprise primitives. Use these classes on admin/partner */
/* pages we deliberately upgrade. Naming: ent-*                       */
/* ---------------------------------------------------------------- */

.ent-page-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e3e7ee;
  margin-bottom: 16px;
  flex-wrap: wrap;
}
.ent-page-head h1 {
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #0b1220;
}
.ent-page-head p {
  color: #6a7689;
  font-size: 0.8125rem;
  margin-top: 2px;
}
.ent-page-head__actions { display: flex; gap: 8px; align-items: center; }

.ent-statbar {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  border: 1px solid #e3e7ee;
  border-radius: 10px;
  background: #ffffff;
  margin-bottom: 16px;
  overflow: hidden;
}
.ent-stat { display: flex; flex-direction: column; gap: 4px; padding: 14px 18px; border-right: 1px solid #e3e7ee; }
.ent-stat:last-child { border-right: none; }
.ent-stat__label { font-size: 0.6875rem; color: #6a7689; text-transform: uppercase; letter-spacing: 0.05em; font-weight: 700; }
.ent-stat__value { font-size: 1.5rem; font-weight: 700; letter-spacing: -0.02em; color: #0b1220; }
.ent-stat__hint { font-size: 0.75rem; color: #6a7689; }

.ent-card { background: #ffffff; border: 1px solid #e3e7ee; border-radius: 10px; box-shadow: none; }
.ent-card--padded { padding: 16px; }
.ent-card--toolbar { display: flex; gap: 12px; align-items: center; padding: 12px 16px; }

.ent-table { width: 100%; border-collapse: separate; border-spacing: 0; }
.ent-table thead th {
  font-size: 0.6875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #6a7689;
  font-weight: 700;
  padding: 10px 12px;
  background: #f6f8fb;
  border-bottom: 1px solid #e3e7ee;
  text-align: left;
}
.ent-table tbody td { padding: 10px 12px; border-bottom: 1px solid #e3e7ee; font-size: 0.8125rem; color: #0b1220; }
.ent-table tbody tr:hover td { background: #f6f8fb; }

.ent-pill {
  display: inline-flex;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  border: 1px solid #c7cfdb;
  background: #ffffff;
  color: #2c3a52;
}
.ent-pill--good { color: #15803d; border-color: #bbf7d0; background: #ecfdf5; }
.ent-pill--warn { color: #b45309; border-color: #fde68a; background: #fffbeb; }
.ent-pill--bad  { color: #b91c1c; border-color: #fecaca; background: #fef2f2; }

.ent-kbd {
  padding: 1px 5px;
  border-radius: 4px;
  border: 1px solid #c7cfdb;
  background: #f6f8fb;
  font-family: ui-monospace, Menlo, monospace;
  font-size: 11px;
  color: #2c3a52;
}

/* Secondary nav bar hosting the category mega-nav */
.topbar-secondary {
  background: var(--surface-alt, #fafafa);
  border-bottom: 1px solid var(--border, #e5e7eb);
  padding: 0 24px;
  height: 44px;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 100;
}

/* Category mega-nav */
.category-mega-nav {
  position: relative;
}
.category-mega-nav__trigger {
  background: none;
  border: 0;
  font: inherit;
  padding: 8px 12px;
  cursor: pointer;
  color: inherit;
}
.category-mega-nav__trigger:hover,
.category-mega-nav__trigger[aria-expanded="true"] {
  background: var(--surface, #fff);
}
.category-mega-nav__fallback {
  padding: 8px 12px;
  color: inherit;
  text-decoration: none;
}
.category-mega-nav__panel {
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 720px;
  max-width: 90vw;
  background: var(--surface, #fff);
  border: 1px solid var(--border, #e5e7eb);
  box-shadow: 0 4px 16px rgba(0,0,0,0.08);
  z-index: 1000;
  display: grid;
  grid-template-columns: 240px 1fr;
  gap: 0;
}
.category-mega-nav__parents-rail {
  display: flex;
  flex-direction: column;
  border-right: 1px solid var(--border, #e5e7eb);
  padding: 8px 0;
}
.category-mega-nav__parent {
  background: none;
  border: 0;
  padding: 10px 16px;
  text-align: left;
  font: inherit;
  cursor: pointer;
  color: inherit;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.category-mega-nav__parent.is-active,
.category-mega-nav__parent:hover {
  background: var(--surface-alt, #f5f5f5);
}
.category-mega-nav__count {
  font-size: 12px;
  opacity: 0.65;
}
.category-mega-nav__children-pane {
  padding: 16px 24px;
}
.category-mega-nav__parent-anchor {
  display: inline-block;
  margin-bottom: 12px;
  font-weight: 600;
  text-decoration: none;
  color: var(--accent-strong, #2563eb);
}
.category-mega-nav__children-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px 24px;
}
.category-mega-nav__child {
  padding: 8px 0;
  color: inherit;
  text-decoration: none;
}
.category-mega-nav__child:hover .category-mega-nav__child-name {
  color: var(--accent-strong, #2563eb);
}
.category-mega-nav__child-name {
  font-size: 14px;
}
.category-mega-nav__child-count {
  font-size: 12px;
  opacity: 0.65;
}

/* Mobile / touch fallback: panel becomes full-width sheet */
@media (hover: none) and (pointer: coarse), (max-width: 767px) {
  .category-mega-nav__panel {
    position: fixed;
    top: auto;
    left: 0;
    right: 0;
    min-width: 0;
    max-width: none;
    grid-template-columns: 1fr;
    max-height: 70vh;
    overflow-y: auto;
  }
  .category-mega-nav__parents-rail {
    border-right: 0;
    border-bottom: 1px solid var(--border, #e5e7eb);
  }
  .category-mega-nav__children-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.enterprise.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;EACE,6DAA6D;AAC/D;;AAEA,2CAA2C;AAC3C;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA,uCAAuC;AACvC;;;EAGE,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;AACpB;;AAEA,gFAAgF;AAChF;EACE,6DAA6D;AAC/D;;AAEA,qEAAqE;AACrE,uEAAuE;AACvE,uEAAuE;AACvE,qEAAqE;;AAErE;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;AACA,0BAA0B,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE;;AAExE;EACE,aAAa;EACb,2DAA2D;EAC3D,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;AACA,YAAY,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,+BAA+B,EAAE;AAClH,uBAAuB,kBAAkB,EAAE;AAC3C,mBAAmB,oBAAoB,EAAE,cAAc,EAAE,yBAAyB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;AAC9H,mBAAmB,iBAAiB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,cAAc,EAAE;AACjG,kBAAkB,kBAAkB,EAAE,cAAc,EAAE;;AAEtD,YAAY,mBAAmB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AACnG,oBAAoB,aAAa,EAAE;AACnC,qBAAqB,aAAa,EAAE,SAAS,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;;AAExF,aAAa,WAAW,EAAE,yBAAyB,EAAE,iBAAiB,EAAE;AACxE;EACE,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;AAClB;AACA,sBAAsB,kBAAkB,EAAE,gCAAgC,EAAE,oBAAoB,EAAE,cAAc,EAAE;AAClH,+BAA+B,mBAAmB,EAAE;;AAEpD;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;AACA,kBAAkB,cAAc,EAAE,qBAAqB,EAAE,mBAAmB,EAAE;AAC9E,kBAAkB,cAAc,EAAE,qBAAqB,EAAE,mBAAmB,EAAE;AAC9E,kBAAkB,cAAc,EAAE,qBAAqB,EAAE,mBAAmB,EAAE;;AAE9E;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;EAC3C,eAAe;EACf,cAAc;AAChB;;AAEA,oDAAoD;AACpD;EACE,uCAAuC;EACvC,+CAA+C;EAC/C,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;AACA;;EAEE,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,wCAAwC;EACxC,uCAAuC;EACvC,aAAa;EACb,aAAa;EACb,gCAAgC;EAChC,MAAM;AACR;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8CAA8C;EAC9C,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;;EAEE,uCAAuC;AACzC;AACA;EACE,eAAe;EACf,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,aAAa;AACf;AACA;EACE,cAAc;EACd,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,aAAa;AACf;;AAEA,4DAA4D;AAC5D;EACE;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,+CAA+C;EACjD;EACA;IACE,qCAAqC;EACvC;AACF","sourcesContent":["/* Enterprise scope for admin and partner roles.\n * Applied via the .portal-enterprise class on the app shell in App.tsx.\n * Designed to be subtle and additive: signals \"this is operations tooling\" without\n * restructuring legacy admin layouts. Most rules are gentle visual shifts.\n */\n\n.portal-enterprise {\n  background: linear-gradient(180deg, #fafbfd 0%, #f3f6fa 100%);\n}\n\n/* Tighten the type on admin page headers */\n.portal-enterprise .page-header h1,\n.portal-enterprise .recruiter-page-header__copy h1 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: #0b1220;\n}\n\n.portal-enterprise .page-header p,\n.portal-enterprise .page-header .muted {\n  color: #6a7689;\n  font-size: 0.875rem;\n}\n\n/* Cards: less rounded, more enterprise table-tool feel */\n.portal-enterprise .card,\n.portal-enterprise .card--toolbar {\n  border-color: #e3e7ee;\n  border-radius: 10px;\n  box-shadow: 0 1px 2px rgba(15,23,42,0.04);\n}\n\n/* Default text color slightly cooler */\n.portal-enterprise,\n.portal-enterprise body,\n.portal-enterprise .container {\n  color: #2c3a52;\n}\n\n/* Tables: tighter rows, subtle zebra */\n.portal-enterprise table {\n  font-size: 0.8125rem;\n}\n.portal-enterprise table thead th {\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  font-size: 0.6875rem;\n  color: #6a7689;\n  background: #f6f8fb;\n  font-weight: 700;\n}\n.portal-enterprise table tbody tr:nth-child(even) td {\n  background: #fafbfd;\n}\n\n/* Status pills: keep them clear but reduce rounding */\n.portal-enterprise .status-pill,\n.portal-enterprise .badge {\n  border-radius: 6px;\n  font-weight: 600;\n}\n\n/* Filter sections: tighten */\n.portal-enterprise .filters-section {\n  border-radius: 10px;\n  background: #ffffff;\n  border: 1px solid #e3e7ee;\n}\n\n/* Buttons: slightly less rounded */\n.portal-enterprise .btn {\n  border-radius: 8px;\n}\n\n/* Sidebar (legacy admin sidebar still applies): make it a touch more reserved */\n.portal-enterprise .sidebar {\n  background: linear-gradient(180deg, #16213b 0%, #1d2a48 100%);\n}\n\n/* ---------------------------------------------------------------- */\n/* Explicit enterprise primitives. Use these classes on admin/partner */\n/* pages we deliberately upgrade. Naming: ent-*                       */\n/* ---------------------------------------------------------------- */\n\n.ent-page-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  gap: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #e3e7ee;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n.ent-page-head h1 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: #0b1220;\n}\n.ent-page-head p {\n  color: #6a7689;\n  font-size: 0.8125rem;\n  margin-top: 2px;\n}\n.ent-page-head__actions { display: flex; gap: 8px; align-items: center; }\n\n.ent-statbar {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  border: 1px solid #e3e7ee;\n  border-radius: 10px;\n  background: #ffffff;\n  margin-bottom: 16px;\n  overflow: hidden;\n}\n.ent-stat { display: flex; flex-direction: column; gap: 4px; padding: 14px 18px; border-right: 1px solid #e3e7ee; }\n.ent-stat:last-child { border-right: none; }\n.ent-stat__label { font-size: 0.6875rem; color: #6a7689; text-transform: uppercase; letter-spacing: 0.05em; font-weight: 700; }\n.ent-stat__value { font-size: 1.5rem; font-weight: 700; letter-spacing: -0.02em; color: #0b1220; }\n.ent-stat__hint { font-size: 0.75rem; color: #6a7689; }\n\n.ent-card { background: #ffffff; border: 1px solid #e3e7ee; border-radius: 10px; box-shadow: none; }\n.ent-card--padded { padding: 16px; }\n.ent-card--toolbar { display: flex; gap: 12px; align-items: center; padding: 12px 16px; }\n\n.ent-table { width: 100%; border-collapse: separate; border-spacing: 0; }\n.ent-table thead th {\n  font-size: 0.6875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #6a7689;\n  font-weight: 700;\n  padding: 10px 12px;\n  background: #f6f8fb;\n  border-bottom: 1px solid #e3e7ee;\n  text-align: left;\n}\n.ent-table tbody td { padding: 10px 12px; border-bottom: 1px solid #e3e7ee; font-size: 0.8125rem; color: #0b1220; }\n.ent-table tbody tr:hover td { background: #f6f8fb; }\n\n.ent-pill {\n  display: inline-flex;\n  padding: 2px 8px;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  border: 1px solid #c7cfdb;\n  background: #ffffff;\n  color: #2c3a52;\n}\n.ent-pill--good { color: #15803d; border-color: #bbf7d0; background: #ecfdf5; }\n.ent-pill--warn { color: #b45309; border-color: #fde68a; background: #fffbeb; }\n.ent-pill--bad  { color: #b91c1c; border-color: #fecaca; background: #fef2f2; }\n\n.ent-kbd {\n  padding: 1px 5px;\n  border-radius: 4px;\n  border: 1px solid #c7cfdb;\n  background: #f6f8fb;\n  font-family: ui-monospace, Menlo, monospace;\n  font-size: 11px;\n  color: #2c3a52;\n}\n\n/* Secondary nav bar hosting the category mega-nav */\n.topbar-secondary {\n  background: var(--surface-alt, #fafafa);\n  border-bottom: 1px solid var(--border, #e5e7eb);\n  padding: 0 24px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  position: relative;\n  z-index: 100;\n}\n\n/* Category mega-nav */\n.category-mega-nav {\n  position: relative;\n}\n.category-mega-nav__trigger {\n  background: none;\n  border: 0;\n  font: inherit;\n  padding: 8px 12px;\n  cursor: pointer;\n  color: inherit;\n}\n.category-mega-nav__trigger:hover,\n.category-mega-nav__trigger[aria-expanded=\"true\"] {\n  background: var(--surface, #fff);\n}\n.category-mega-nav__fallback {\n  padding: 8px 12px;\n  color: inherit;\n  text-decoration: none;\n}\n.category-mega-nav__panel {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  min-width: 720px;\n  max-width: 90vw;\n  background: var(--surface, #fff);\n  border: 1px solid var(--border, #e5e7eb);\n  box-shadow: 0 4px 16px rgba(0,0,0,0.08);\n  z-index: 1000;\n  display: grid;\n  grid-template-columns: 240px 1fr;\n  gap: 0;\n}\n.category-mega-nav__parents-rail {\n  display: flex;\n  flex-direction: column;\n  border-right: 1px solid var(--border, #e5e7eb);\n  padding: 8px 0;\n}\n.category-mega-nav__parent {\n  background: none;\n  border: 0;\n  padding: 10px 16px;\n  text-align: left;\n  font: inherit;\n  cursor: pointer;\n  color: inherit;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n.category-mega-nav__parent.is-active,\n.category-mega-nav__parent:hover {\n  background: var(--surface-alt, #f5f5f5);\n}\n.category-mega-nav__count {\n  font-size: 12px;\n  opacity: 0.65;\n}\n.category-mega-nav__children-pane {\n  padding: 16px 24px;\n}\n.category-mega-nav__parent-anchor {\n  display: inline-block;\n  margin-bottom: 12px;\n  font-weight: 600;\n  text-decoration: none;\n  color: var(--accent-strong, #2563eb);\n}\n.category-mega-nav__children-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px 24px;\n}\n.category-mega-nav__child {\n  padding: 8px 0;\n  color: inherit;\n  text-decoration: none;\n}\n.category-mega-nav__child:hover .category-mega-nav__child-name {\n  color: var(--accent-strong, #2563eb);\n}\n.category-mega-nav__child-name {\n  font-size: 14px;\n}\n.category-mega-nav__child-count {\n  font-size: 12px;\n  opacity: 0.65;\n}\n\n/* Mobile / touch fallback: panel becomes full-width sheet */\n@media (hover: none) and (pointer: coarse), (max-width: 767px) {\n  .category-mega-nav__panel {\n    position: fixed;\n    top: auto;\n    left: 0;\n    right: 0;\n    min-width: 0;\n    max-width: none;\n    grid-template-columns: 1fr;\n    max-height: 70vh;\n    overflow-y: auto;\n  }\n  .category-mega-nav__parents-rail {\n    border-right: 0;\n    border-bottom: 1px solid var(--border, #e5e7eb);\n  }\n  .category-mega-nav__children-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
